import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=bf1136b6"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"
import style0 from "./Journal.vue?vue&type=style&index=0&id=bf1136b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports